
try {

    //@ts-expect-error
    window.dataLayer = window?.dataLayer || [];

} catch (error) {

}

export function gtag(...args: any[]) {
    try {
        //@ts-expect-error
        dataLayer.push(arguments);
    } catch (error) {

    }
}
export function gpush(data) {
    try {
        //@ts-expect-error
        dataLayer.push(data);
    } catch (error) {

    }
}
export function gpage(data) {
    try {
        //@ts-expect-error
        window.pageContextData = data
    } catch (error) {

    }
}
export function CookieScript() {
    try {
        //@ts-expect-error
       return CookieScript.instance;
    } catch (error) {

    }
}



